module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 11.00ed0238.png";